export const notificationsValues = {
  immediately: {
    value: 'immediately',
    label: 'Immediate',
    track: 'Realtime',
  },
  daily: {
    value: 'daily',
    label: 'Una volta al giorno',
    track: 'Daily',
  },
  never: {
    value: 'never',
    label: '',
    track: 'Never',
  },
};
